export default function MobileBottomSheetHeader({onDismiss, title = ""}) {
    return (
        <div className="container pt-1.5">
            <div className="flex items-center justify-between">
                <p className="font-bold text-pol-dark-800">{title}</p>
                <button onClick={onDismiss}>
                    <i className="icon-thin-times text-base text-pol-red ml-3.5"/>
                </button>
            </div>
        </div>
    )
}
